import { Controller } from '@hotwired/stimulus'

const HEX_RE = /^#[0-9a-fA-F]{6}$/
const VARIABLE_BY_FIELD = {
  background: ['--color-base-100', '--color-base-200'],
  text: ['--color-base-content'],
  accent: ['--color-primary'],
}

export default class extends Controller {
  static targets = [
    'preview',
    'backgroundHex',
    'backgroundPicker',
    'textHex',
    'textPicker',
    'accentHex',
    'accentPicker',
  ]

  connect() {
    this.sync('background')
    this.sync('text')
    this.sync('accent')
  }

  onHexInput(event) {
    const field = event.params.field
    const value = event.target.value.trim()
    this.updatePicker(field, value)
    this.applyVariable(field, value)
  }

  onPickerInput(event) {
    const field = event.params.field
    const value = event.target.value
    this.updateHex(field, value)
    this.applyVariable(field, value)
  }

  sync(field) {
    const hex = this.hexInput(field)
    if (!hex) return
    const value = hex.value.trim()
    this.updatePicker(field, value)
    this.applyVariable(field, value)
  }

  applyVariable(field, value) {
    if (!HEX_RE.test(value)) return
    if (!this.hasPreviewTarget) return
    const variables = VARIABLE_BY_FIELD[field]
    if (!variables) return
    const normalized = value.toLowerCase()
    variables.forEach((name) => {
      this.previewTarget.style.setProperty(name, normalized)
    })
    if (field === 'accent') {
      this.previewTarget.style.setProperty(
        '--color-primary-content',
        this.contrastFor(normalized),
      )
    }
  }

  contrastFor(hex) {
    const r = parseInt(hex.slice(1, 3), 16)
    const g = parseInt(hex.slice(3, 5), 16)
    const b = parseInt(hex.slice(5, 7), 16)
    const yiq = (r * 299 + g * 587 + b * 114) / 1000
    return yiq >= 128 ? '#000000' : '#ffffff'
  }

  updatePicker(field, value) {
    if (!HEX_RE.test(value)) return
    const picker = this.pickerInput(field)
    if (picker) picker.value = value.toLowerCase()
  }

  updateHex(field, value) {
    const hex = this.hexInput(field)
    if (hex) hex.value = value.toLowerCase()
  }

  hexInput(field) {
    return this[`${field}HexTarget`]
  }

  pickerInput(field) {
    return this[`${field}PickerTarget`]
  }
}
